import { registerCollisionAnimation } from './CollisionAnimationRegistry';

registerCollisionAnimation('ELASTIC_RING', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  ctx.strokeStyle = determineColor(0, 1);
  ctx.lineWidth = 3;
  ctx.globalAlpha = 1 - progress;
  ctx.beginPath();
  const baseR = e.radius * 2 * (1 + progress);
  for (let a = 0; a <= Math.PI * 2; a += 0.1) {
    const wob = Math.sin(a * 10 + elapsed * 0.02) * 20 * (1 - progress);
    const r = baseR + wob;
    const x = e.pos.x + Math.cos(a) * r;
    const y = e.pos.y + Math.sin(a) * r;
    if (a === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
  }
  ctx.closePath(); ctx.stroke();
});
